export const setAdminToken = (token) => {
    localStorage.setItem("accessToken", token)
}

export const setAdminType = (type) => {
    localStorage.setItem("accType", type)
}